import React from "react";
import { X, Minus, Plus, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useShop } from "../context/ShopContext";
import { formatINR } from "../lib/api";

export default function CartDrawer({ open, onClose }) {
  const { cart, updateQty, removeFromCart, cartSubtotal } = useShop();

  return (
    <>
      <div
        className={`fixed inset-0 z-50 bg-black/70 transition-opacity ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={onClose}
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 z-50 h-full w-full sm:w-[440px] bg-[#0E0E0E] border-l border-white/10 transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"} flex flex-col`}
      >
        <div className="flex items-center justify-between p-5 border-b border-white/10">
          <div>
            <div className="overline">Your Bag</div>
            <h3 className="font-display text-xl uppercase tracking-tight">Cart ({cart.length})</h3>
          </div>
          <button data-testid="cart-drawer-close" onClick={onClose} className="text-white/70 hover:text-white"><X /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          {cart.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-white/60 font-body">Your bag is empty.</p>
              <Link to="/shop" onClick={onClose} className="btn-ghost mt-5 inline-flex">Start Shopping</Link>
            </div>
          ) : cart.map((item) => (
            <div key={item.product_id} data-testid={`cart-item-${item.slug}`} className="flex gap-4 border-b border-white/5 pb-4">
              <img src={item.image} alt={item.name} className="w-20 h-24 object-cover" />
              <div className="flex-1">
                <h4 className="font-display text-sm uppercase tracking-tight line-clamp-2">{item.name}</h4>
                <div className="text-[#D96A1B] font-display text-sm mt-1">{formatINR(item.price)}</div>
                <div className="flex items-center justify-between mt-3">
                  <div className="flex items-center border border-white/15">
                    <button data-testid={`qty-minus-${item.slug}`} onClick={() => updateQty(item.product_id, item.quantity - 1)} className="p-1.5 text-white/70 hover:text-white"><Minus size={14} /></button>
                    <span className="px-3 text-sm font-display">{item.quantity}</span>
                    <button data-testid={`qty-plus-${item.slug}`} onClick={() => updateQty(item.product_id, item.quantity + 1)} className="p-1.5 text-white/70 hover:text-white"><Plus size={14} /></button>
                  </div>
                  <button data-testid={`remove-item-${item.slug}`} onClick={() => removeFromCart(item.product_id)} className="text-white/40 hover:text-[#D96A1B]"><Trash2 size={16} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {cart.length > 0 && (
          <div className="border-t border-white/10 p-5 space-y-4">
            <div className="flex justify-between items-baseline">
              <span className="overline">Subtotal</span>
              <span data-testid="cart-subtotal" className="font-display text-2xl">{formatINR(cartSubtotal)}</span>
            </div>
            <p className="text-xs text-white/50 font-body">Shipping and taxes calculated at checkout.</p>
            <Link to="/checkout" onClick={onClose} data-testid="cart-checkout-btn" className="btn-orange w-full justify-center">
              Checkout
            </Link>
          </div>
        )}
      </aside>
    </>
  );
}
